import { render, staticRenderFns } from "./ConfirmProjectUpdateModal.vue?vue&type=template&id=6af9ebd4&scoped=true&"
import script from "./ConfirmProjectUpdateModal.vue?vue&type=script&lang=ts&"
export * from "./ConfirmProjectUpdateModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af9ebd4",
  null
  
)

export default component.exports